// extracted by mini-css-extract-plugin
export default {"modal":"ErrorModal_modal__0VCrq","container":"ErrorModal_container__XT4jk","bodycontainer":"ErrorModal_bodycontainer__ZzCDz","button":"ErrorModal_button__Fe1DY"};